<template>

<div v-if="authorized">
    <slot>

    </slot>


  </div>



</template>
<script>

  export default {
    name:'auth',
    data() {
      return {}
    },

    props:{
      permissions: Array,

    },
    computed: {
      authorized: {
        get() {
          //  this.ociLog(this.$store.getters.userRoles[0].role);
          if (this.$store.getters.userRoles.length > 0) {
            var roles = this.$store.state.appUser.roles;
            for (let j = 0; j < this.permissions.length; j++) {
              for (let i = 0; i < roles.length; i++) {
                if (roles[i].role === this.permissions[j]) {
                  return true;
                }
              }
            }

          }
          return false;
        }

      }

      },
  }
</script>
<style>

</style>
